var map = {
	"./account.png": "rzv0",
	"./alarm-clock.png": "tjtx",
	"./avator-man.png": "1OgB",
	"./avator-woman.png": "4IQ2",
	"./banner.png": "P07D",
	"./class-answer-tag.png": "gPed",
	"./class-status.png": "FliF",
	"./close.png": "/TeD",
	"./empty.png": "Bm30",
	"./eye-close.png": "KBpv",
	"./eye-open.png": "Y6uR",
	"./ga.png": "Wje2",
	"./illness-accuracy.png": "qLgo",
	"./man.png": "JBOh",
	"./medal-illness.png": "eTld",
	"./medal-study.png": "uW+Y",
	"./medal-theory.png": "sha1",
	"./open.png": "8r3S",
	"./password.png": "aemX",
	"./player-killing-VS.png": "3kLT",
	"./search.png": "NzrC",
	"./success.png": "4AGf",
	"./theory-accuracy.png": "9H1k",
	"./trophy-first.png": "OM2c",
	"./trophy-second.png": "OHJL",
	"./trophy-third.png": "4X7f",
	"./view-details.png": "fzVQ",
	"./woman.png": "jr7H",
	"./yx.png": "X17H"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "tsha";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/.*\.png$
// module id = tsha
// module chunks = 3